import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const OperadorParametrosFaixaBancariaService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'operador-parametros-faixa-bancaria/excel/deletar', 'excelOperadorParametrosFaixaBancariaDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'operador-parametros-faixa-bancaria/excel', 'excelOperadorParametrosFaixaBancaria');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('operador-parametros-faixa-bancaria/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('operador-parametros-faixa-bancaria/eventGrid', {});
    }
}

export default OperadorParametrosFaixaBancariaService